'use strict';

(function (scope) {
    /**
     * Abstract parameters used for recognition
     *
     * @class AbstractParameter
     * @constructor
     */
    function AbstractParameter() {
    }

    // Export
    scope.AbstractParameter = AbstractParameter;
})(MyScript);